import {Rate} from "antd"
import { FC } from "react"

import styles from "../styles/Card.module.scss"

interface BarberCardProps {
  item: any
  onClick: (ev: any) => void
}

const BarberCard: FC<BarberCardProps> = ({
  item, onClick
}) => {
  return (
    <>
      <div className={styles.card} onClick={onClick}>
        <div className={styles.barber}>
          <div className={styles.b_avatar} style={{backgroundImage: `url(${item.avatar})`}}></div>
          <div className={styles.b_data}>
            <div className={styles.b_data__name}>{item.name}</div>
            <div className={styles.b_data__spec}>{item.specialization}</div>
            <div className={styles.b_data__rate}><b>{item.rating.toFixed(2)}</b> <Rate style={{fontSize: "16px"}} value={item.rating} allowHalf={true} disabled={true} /></div>
          </div>
        </div>
        <div className={styles.card_arrow}><i className="fas fa-chevron-right"></i></div>
        <div className={styles.dates}>
          <div className={styles.d_title}>Ближайшие рабочие дни:</div>
          <div className={styles.d_tripler}>
            {item.dates.map(v => <div>{v}</div>)}
          </div>
        </div>
      </div>
    </>
  )
}

export default BarberCard